export const STAT_ITEM_TYPE_OPTIONS = [
    'Attacks',
    'BallSafe',
    'Corners',
    'CornersF',
    'CornersH',
    'YellowCards',
    'DangerousAttacks',
    'Fouls',
    'FreeKicks',
    'GoalKicks',
    'Goals',
    'GoalAttempts',
    'Penalties',
    'Offsides',
    'OffTarget',
    'OnTarget',
    'RedCards',
    'PosessionRt',
    'ShotsBlocked',
    'Substitutions',
    'Throwins',
    'YellowRedCards',
    'Saves',
    'Assists',
    'Steals',
    'Tackles',
    'ExpectedGoals',
    'BigChances',
    'ShotsInsidePenaltyArea',
    'ShotsOutsidePenaltyArea',
    'HitWoodwork',
    'Crosses',
    'Clearances',
    'ExpectedGoalsOnTarget',
    'TouchesInOppositionBox',
    'LongBalls',
    'PassesInFinalThird',
    'ExpectedAssists',
    'DuelsWon',
    'ErrorsLeadingToShot',
    'ErrorsLeadingToGoal',
    'ExpectedGoalsOnTargetFaced',
    'GoalsPrevented',
    'AccurateThroughPasses',
    'TotalShots'
] as const;

export const STAT_UNIT_TYPE_OPTIONS = ['NONE', 'INT', 'FLOAT', 'PERCENTAGE'] as const;

export const MATCH_HISTORY_TYPE_OPTIONS = [
    'RegularGoal',
    'Substitution',
    'YellowCard',
    'RedCard',
    'PenaltyGoal',
    'GoalDisallowed',
    'OwnGoal',
    'PenaltyMissed',
] as const;
